import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-alert',
  templateUrl: './info-alert.component.html',
  styleUrls: ['./info-alert.component.scss'],
  standalone: false
})
export class InfoAlertComponent {
  @Input() message: string = '';
  @Input() type: 'info' | 'warning' | 'error' | 'success' = 'info';

  get iconName(): string {
    switch (this.type) {
      case 'warning':
        return 'alert-circle-outline';
      case 'error':
        return 'close-circle-outline';
      case 'success':
        return 'checkmark-circle-outline';
      default:
        return 'information-circle-outline';
    }
  }
}